/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [emoji-editor.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 11.10.18 17:00
 */
import emojione from '../../../node_modules/emojione/lib/js/emojione';

import {emojifilters} from './emoji-filter';
import React, {useEffect, useRef, useState} from 'react';
import {RoundedButton} from "../navigation/buttons/nav-buttons";
import NavigationToggler from "../navigation-headlines/navigation-toggler";
import {useIsMobile, useLanguage} from "../configuration/configuration";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import {
    BeachAccessOutlined,
    FavoriteBorderOutlined,
    FlagOutlined,
    FlightOutlined,
    InsertEmoticonOutlined,
    PetsOutlined,
    RestaurantOutlined,
    Send,
    SportsSoccerOutlined
} from "@material-ui/icons";
import SmoothScrollbar from "../scrollbars/smooth-scrollbar";

// emojione.imageType = 'png';
// emojione.sprites = true;

// used by EmojiToggler
const smileyFamilies = [
    {family: 'smileys_people', icon: () => <InsertEmoticonOutlined fontSize='small' aria-hidden="true"/>},
    {family: 'animals_nature', icon: () => <PetsOutlined fontSize='small' aria-hidden="true"/>},
    {family: 'food_drink', icon: () => <RestaurantOutlined fontSize='small' aria-hidden="true"/>},
    {family: 'activity', icon: () => <SportsSoccerOutlined fontSize='small' aria-hidden="true"/>},
    {family: 'travel_places', icon: () => <FlightOutlined fontSize='small' aria-hidden="true"/>},
    {family: 'objects', icon: () => <BeachAccessOutlined fontSize='small' aria-hidden="true"/>},
    {family: 'symbols', icon: () => <FavoriteBorderOutlined fontSize='small' aria-hidden="true"/>},
    {family: 'flags', icon: () => <FlagOutlined fontSize='small' aria-hidden="true"/>}
];

const EmojiButton = ({shortName, onClick}) => {
    const emojiRef = useRef();

    useEffect(() => {
        emojiRef.current.innerHTML = emojione.shortnameToImage(emojiRef.current.innerHTML);
    }, [shortName])

    return <button key={shortName} className='emoji-family-icon'
                   ref={emojiRef}
                   onClick={onClick}>
        {`:${shortName}:`}
    </button>;

}

const EmojiFamily = ({id, family, onClick}) => {

    const handleEmojiClick = (event) => {
        event.preventDefault();
        onClick(event.target.getAttribute("title"));
    }

    const renderEmojiFamily = (id, family) => {
        return emojifilters[family].emoji
        .split(" ")
        .map(shortName => {
            return <EmojiButton key={shortName} shortName={shortName} onClick={handleEmojiClick}/>
        });
    }

    return <SmoothScrollbar destroy={false} className='emoji-content'>
        <div className="emoji-family">
            {renderEmojiFamily(id, family)}
        </div>
    </SmoothScrollbar>
}

const EmojiToggler = ({id, onClick, onEnter}) => {
    const [showEmojis, setShowEmojis] = useState(false);
    const [family, setFamily] = useState(null);
    const emojiRef = useRef(null);
    const Lang = useLanguage();
    const isMobile = useIsMobile();

    const toggleFamily = (event) => {
        const currentFamily = event.currentTarget.dataset.target;
        event.preventDefault();

        if (family !== currentFamily) {
            setFamily(currentFamily);
            emojiRef.current && emojiRef.current.show();
            return;
        }
        emojiRef.current && emojiRef.current.toggle();
    };

    const renderEmojiFamilyNav = () => {
        return smileyFamilies.map(smiley => {
            return <RoundedButton key={smiley.family}
                                  data-target={smiley.family}
                                  onClick={toggleFamily}>
                {smiley.icon()}
            </RoundedButton>
        });
    }

    const handleShowEmojis = (event) => {
        event.preventDefault();
        emojiRef.current && emojiRef.current.toggle();
        setShowEmojis(!showEmojis);
    }

    const renderNavigation = (id) => {
        return <NavigationRow className='emoji-navigation mt-1'>
            {showEmojis && <NavigationGroup>
                {renderEmojiFamilyNav()}
            </NavigationGroup>}
            {!showEmojis && <NavigationGroup/>}
            <NavigationGroup>
                {!isMobile && <RoundedButton className='ml-1' title='Emoticons'
                               onClick={handleShowEmojis}>
                    <InsertEmoticonOutlined aria-hidden="true"/>
                </RoundedButton>}
                <RoundedButton className='btn-primary ml-1' title={Lang.post.editor.saveTooltip}
                               onClick={onEnter}>
                    <Send fontSize='small' aria-hidden="true" className='clr-white'/>
                </RoundedButton>
            </NavigationGroup>
        </NavigationRow>
    }

    return <div className='emoji-toggler'>
        {renderNavigation(id)}

        {family && showEmojis && <NavigationToggler show onRef={(ref) => emojiRef.current = ref}>
            <EmojiFamily id={id} family={family} onClick={onClick}/>
        </NavigationToggler>}
    </div>
}

export default EmojiToggler;
